export default __webpack_public_path__ + "static/media/shingle.a11e1b49.jpeg";